module.exports = __webpack_public_path__ + "static/freemasons-hall-inside-2949e28f81f24dabecccf66d4ebddc79.jpg";